// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\ModifyReservations\CancelReservationsRequest.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// CancelReservationsRequestData is the class that CancelReservationsRequest serializes to/from
export interface CancelReservationsRequestData {
	
	
    Remarks : string | null;
    ReservationIds : number[];
}

// CancelReservationsRequestOptions is the class which may be passed to the CancelReservationsRequest constructor to define optional initial data values
export interface CancelReservationsRequestOptions {
	
	
    Remarks? : string | null;
    ReservationIds? : number[];
}

export class CancelReservationsRequest {
	
	
    public Remarks : DataSignal<string | null>;
    public ReservationIds : SDataArray<number>;

    constructor();
    constructor(data : CancelReservationsRequestOptions);
    constructor(data: CancelReservationsRequestOptions | null = null) {
	    
	    
        this.Remarks = jsonableObservable(S.value<string | null>(data && data.Remarks !== undefined ? data.Remarks : null));
        this.ReservationIds = jsonableObservable(SArray<number>(data && data.ReservationIds !== undefined ? data.ReservationIds : []));
    }

    static key(obj : CancelReservationsRequest) {
        return ;
    }
    
    static dataKey(obj : CancelReservationsRequestOptions) {
        return ;
    }

    static update(obj : CancelReservationsRequest, data : CancelReservationsRequestOptions) {
        S.freeze(() => {
	        
	        
            if (data.Remarks !== undefined) obj.Remarks(data.Remarks);
            if (data.ReservationIds !== undefined) obj.ReservationIds(data.ReservationIds);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CancelReservationsRequest.ts